import request from '@/utils/request'
import URL from '@/api/urlTranslator'

/**
 * 保存用户安全策略
 * @returns {*}
 */
export function saveUserSecurityPolicyFunc(data) {
  return request({
    url: URL.sys.saveUserSecurityPolicyUrl,
    method: 'post',
    data
  })
}

/**
 * 检查密码是否符合规则
 * @returns {*}
 */
export function checkPasswordRuleFunc(data) {
  return request({
    url: URL.sys.checkPasswordRuleUrl,
    method: 'post',
    data
  })
}

/**
 * 查询用户安全策略
 * @param params
 * @returns {*}
 */
export function queryUserSecurityPolicyFunc(params) {
  return request({
    url: URL.sys.queryUserSecurityPolicyUrl,
    method: 'get',
    params
  })
}

